import {useScrollytellState} from "../Admin/scrollytellContext";

export const useIsActiveBlock = ({sectionId, containerId, blockId}) => {
    const { activeElement } = useScrollytellState()

    return activeElement[0] === sectionId && activeElement[1] === containerId && activeElement[2] === blockId
}